import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Blue CTA',
  name: 'blueCTA',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Description',
      name: 'content',
      type: 'array',
      of: strongEmLink,
      validation: (Rule) => Rule.required(),
    }),
  ],
})